import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";

const ThumbColors = {
  10: "#22C461",
  30: "#D3CD5B",
  50: "#FFA14B",
  70: "#F6603E",
  90: "#DC1A2E",
};

export default function CustomSlider({
  marks,
  value,
  onChange,
  disabled = false,
}) {
  const { t } = useTranslation();

  return (
    <Box sx={{ width: "100%" }} className="question-slider-wrap">
      <Typography id="question-slider" className="text-capitalize" gutterBottom>
        {t("questions.bulkQuestionForm.difficultyLevel")}{" "}
        <span className="text-red">*</span>
      </Typography>
      <Slider
        sx={{
          "& .MuiSlider-rail": {
            background:
              "linear-gradient(to right, #22C461 20%, #D3CD5B 21%, #D3CD5B 40%, #FFA14B 41% ,#FFA14B 60%,#F6603E 61% ,#F6603E 80%,#DC1A2E 81%,#DC1A2E 100%)",
            opacity: 1,
          },
          "& .MuiSlider-mark": {
            background: "transparent",
          },
          "& .MuiSlider-thumb": {
            background: "white",
            width: 15,
            height: 15,
            border: "solid 3px",
            borderColor: ThumbColors[value] ?? "#DC1A2E",
          },
          "& .MuiSlider-valueLabel": {
            "& > *": {
              background: "black",
            },
          },
          pointerEvents: disabled ? "none" : "",
        }}
        min={0}
        step={null}
        marks={marks}
        defaultValue={10}
        onChange={onChange}
        value={Number(value)}
        valueLabelDisplay="auto"
        aria-labelledby="question-slider"
      />
    </Box>
  );
}
